import { forwardRef, useMemo, useState } from 'react';

import { RiErrorWarningLine } from 'react-icons/ri';

import {
  Autocomplete as MantineAutocomplete,
  AutocompleteProps as MantineAutocompleteProps
} from '@mantine/core';

import { InputLoader } from '../../feedback';
import { useMergeClassNames } from '../../utils';
// Auto complete shares styles from Select
import { SelectOverrideClassNames } from '../select';

interface AutocompleteProps extends MantineAutocompleteProps {
  loading?: boolean;
}

const Autocomplete = forwardRef<HTMLInputElement, AutocompleteProps>(
  (
    {
      loading,
      size = 'xl',
      leftSection,
      rightSection,
      error,
      data,
      onFocus,
      onBlur,
      classNames,
      ...rest
    },
    ref
  ) => {
    const [focussed, setFocussed] = useState<boolean>(false);

    const rightSectionFinal = loading ? (
      <InputLoader size={size} />
    ) : error ? (
      <RiErrorWarningLine />
    ) : rightSection ? (
      rightSection
    ) : undefined;

    const classes = useMemo(() => {
      const classes = {
        ...SelectOverrideClassNames({
          size,
          focussed,
          error
        })
      };
      return classes;
    }, [size, focussed, error]);

    const handleFocus = (e: React.FocusEvent<HTMLInputElement, Element>) => {
      setFocussed(true);
      onFocus && onFocus(e);
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement, Element>) => {
      setFocussed(false);
      onBlur && onBlur(e);
    };

    const mergedClassNames = useMergeClassNames({
      classNames: [classes, classNames]
    });

    return (
      <MantineAutocomplete
        {...rest}
        ref={ref}
        data={data}
        onFocus={handleFocus}
        onBlur={handleBlur}
        size={size}
        leftSection={leftSection}
        rightSection={rightSectionFinal}
        error={error}
        classNames={mergedClassNames}
      />
    );
  }
);

export { Autocomplete };
export type { AutocompleteProps };
